import { applyWebAwesomeTheme } from './styles/webawesome-theme.js';
import {
  ensureAccountAuthenticated,
  initAccountAuth,
} from './services/account-auth.js';
import { ensureWebAwesomeReady, markAppReady } from './lib/webawesome-ready.js';

applyWebAwesomeTheme();

void (async () => {
  const pathname = window.location.pathname;
  const isAuthPage = pathname === '/auth';
  const params = new URLSearchParams(window.location.search);

  // Kick off WA preload in parallel with auth so we don't block on it.
  const waReady = ensureWebAwesomeReady();

  // Process Identity email/OAuth hash before the account gate check.
  await initAccountAuth();

  const accountAuthed = await ensureAccountAuthenticated();
  if (!accountAuthed) {
    const root = document.createElement('momo-account-auth');
    document.body.appendChild(root);
    await import('./components/account-auth-page.js');
    await waReady;
    markAppReady(root);
    return;
  }

  // Production SCHWAB_REDIRECT_URI may land on /auth or another path — normalize to home
  // so the in-app broker connect modal can exchange the code.
  if (params.has('code') || params.has('error')) {
    if (pathname !== '/') {
      window.location.replace(`/${window.location.search}`);
      return;
    }
  }

  if (isAuthPage && !params.has('code') && !params.has('error')) {
    window.location.replace('/');
    return;
  }

  // `/` and `/performance` share momo-app (client-side routing). Auth stays separate.
  const tag = isAuthPage ? 'momo-schwab-auth' : 'momo-app';
  const root = document.createElement(tag);
  document.body.appendChild(root);

  if (isAuthPage) {
    await import('./components/schwab-auth-page.js');
  } else {
    await import('./app-shell.js');
  }

  // Only reveal after the host exists AND WA components are ready (or timed out).
  await waReady;
  markAppReady(root);
})();
